export default function DashboardShopView() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[400px]">
      <div className="flex items-center justify-center w-20 h-20 rounded-full bg-muted mb-4">
        <span className="text-5xl text-muted-foreground">🚧</span>
      </div>
      <h2 className="text-2xl font-bold text-center mb-2">เร็ว ๆ นี้</h2>
      <p className="text-muted-foreground text-center">
        ฟีเจอร์แดชบอร์ดสำหรับร้านค้ากำลังอยู่ในระหว่างการพัฒนา
        <br />
        โปรดรอติดตามการอัปเดตในอนาคต
      </p>
    </div>
  )
}
